import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUserDetails } from '../helper/sessionHelper';

const PrivateRoute = ({children}) => {
    const location = useLocation();
    const user = getUserDetails()
    if (user) {
        return children
    }
    return <Navigate to={'/login'} state={{ from: location }} />
};

export default PrivateRoute;